import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'menu-bar',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class MenuBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openApplicationForm() {
    window.open('assets/pdf/2025/application.pdf', '_blank')
  }
}
